import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';
import { Button, Grid, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import StatusFilterSelect from 'common/components/StatusFilterSelect';
export const TextFilterBy = styled(Typography)`
    font-size: 14px;
    font-style: normal;
    font-weight: bold;
    line-height: 17px;
    margin-bottom: 0;
`;

const FilterAndCreate = ({
    contactIsArchived,
    filterData,
    handleClickCreate,
    handleOnSelectStatus,
    isFetching,
    projectId,
}) => {
    const { t } = useTranslation();
    return (
        <Grid container mt={1}>
            <Grid size={{ md: 4, xs: 18 }}>
                <StatusFilterSelect
                    filterBy={filterData?.status}
                    handleSelected={handleOnSelectStatus}
                    variant="outlined"
                />
            </Grid>

            <Grid size={{ md: 14, xs: 18 }} textAlign="right">
                <Button
                    disabled={isFetching}
                    endIcon={<AddIcon />}
                    onClick={() => handleClickCreate(projectId)}
                    variant="outlined"
                    visible={
                        !contactIsArchived && filterData?.status === 'active'
                    }
                    sx={{ width: { md: 'auto', xs: '100%' } }}
                >
                    {t('Create proposal')}
                </Button>
            </Grid>
        </Grid>
    );
};

FilterAndCreate.propTypes = {
    contactIsArchived: PropTypes.bool,
    filterData: PropTypes.object,
    handleClickCreate: PropTypes.func,
    handleOnSelectStatus: PropTypes.func,
    isFetching: PropTypes.bool,
    projectId: PropTypes.string,
};

export default FilterAndCreate;
